import {
  DropdownHierarchyProps,
  DropdownItemProps,
  DropdownProps,
} from "/App.GeneratedTypes";

export const GetDropdownItem = (dropdown?: DropdownProps, value?: string) =>
  dropdown?.items?.find((i) => i.value === value);

export const GetDropdownHierarchyItem = (
  dropdown?: DropdownHierarchyProps,
  value?: string
): DropdownItemProps | undefined => {
  let result = GetDropdownItem(dropdown, value);
  if (result) return result;
  for (let i = 0; i < (dropdown?.innerDropdowns?.length ?? 0); ++i) {
    result = GetDropdownItem(dropdown?.innerDropdowns[i], value);
    if (result) return result;
  }
};
